import React from 'react';
import { Link, Switch, Route } from 'react-router-dom';

import { UtilityHeaderLayout } from 'design/utilityHeaderLayout';
import { routes } from 'utils/routes';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';

export const UtilityHeader = () => {
  const logoNode = React.useMemo(() => {
    return (
      <LinkControlComponent to={ORIGIN_SITE_URL}>
        <TextComponent color="primary" size="l">
          AGM
        </TextComponent>
      </LinkControlComponent>
    );
  }, []);

  const linksNode = React.useMemo(() => {
    return (
      <Switch>
        <Route
          path={[
            routes.registrationProdPattern(),
            routes.registrationDemoPattern(),
          ]}
        >
          <Link to="/">
            <TextComponent size="s" color="secondary">
              Личный кабинет
            </TextComponent>
          </Link>
        </Route>
      </Switch>
    );
  }, []);

  return <UtilityHeaderLayout logoNode={logoNode} linksNode={linksNode} />;
};
